import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@web/atoms';
import {
  StyledInformationStats,
  InformationStatsBlocksContainer,
  Paragraph,
} from './styles.js';
import { InfoStatBlock } from './InfoStatBlock.js';

export const InformationStats = ({
  heading,
  subheading,
  headingLevel,
  typography = 'heading1',
  statBlocks,
  backgroundColor = 'background.base',
  fontColor = 'neutral.dark',
}) => {
  const calculateColumns =
    statBlocks.length % 4 === 0 || statBlocks.length < 4 ? 4 : 3;

  return (
    <StyledInformationStats $backgroundColor={backgroundColor}>
      <Heading
        headingLevel={headingLevel}
        typography={typography}
        headingText={heading}
        backgroundColor={backgroundColor}
        fontColor={fontColor}
        position="center"
        verticalPadding={0}
        horizontalPadding={0}
      />
      <Paragraph $fontColor={fontColor}>{subheading}</Paragraph>

      <InformationStatsBlocksContainer $columns={calculateColumns}>
        {statBlocks.map((item, index) => (
          <InfoStatBlock {...item} key={index} />
        ))}
      </InformationStatsBlocksContainer>
    </StyledInformationStats>
  );
};

InformationStats.displayName = 'InformationStats';

InformationStats.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  typography: PropTypes.string,
  statBlocks: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      textColor: PropTypes.string,
      description: PropTypes.string,
    }),
  ).isRequired,
  backgroundColor: PropTypes.string,
  fontColor: PropTypes.string,
};
